"use client";

import { useEffect } from "react";
import { useAuth } from "@clerk/clerk-react";
import { useMutation } from "convex/react";
import { api } from "../../../convex/_generated/api";

const HEARTBEAT_MS = 30_000;

export function WebPresence() {
  const { isLoaded, isSignedIn } = useAuth();
  const updateOnlineStatus = useMutation(api.users.updateOnlineStatus);

  useEffect(() => {
    if (!isLoaded || !isSignedIn) return;

    let cancelled = false;

    const setOnline = async (isOnline: boolean) => {
      try {
        await updateOnlineStatus({ isOnline });
      } catch {
        // Presence is best-effort.
      }
    };

    void setOnline(true);

    const interval = window.setInterval(() => {
      if (cancelled) return;
      void setOnline(true);
    }, HEARTBEAT_MS);

    const onVisibility = () => {
      if (document.visibilityState === "hidden") {
        void setOnline(false);
      } else {
        void setOnline(true);
      }
    };

    const onUnload = () => {
      void setOnline(false);
    };

    document.addEventListener("visibilitychange", onVisibility);
    window.addEventListener("beforeunload", onUnload);

    return () => {
      cancelled = true;
      clearInterval(interval);
      document.removeEventListener("visibilitychange", onVisibility);
      window.removeEventListener("beforeunload", onUnload);
      void setOnline(false);
    };
  }, [isLoaded, isSignedIn, updateOnlineStatus]);

  return null;
}

